module.exports = __webpack_public_path__ + "static/media/0.58a1aeff.jpg";